import { useCallback, useRef } from 'react';

/**
 * Hook for managing form field hidden state via props.hidden (CSS hiding).
 * Form fields use props.hidden instead of data.hidden to remain in the DOM
 * for form submission while being visually hidden.
 */
export const useFormFieldHiddenSync = <T extends { hidden?: boolean }>(
  fieldNodeId: string | undefined,
  _propsHidden: boolean | undefined,
  setProp: (callback: (props: T) => void) => void,
) => {
  const setPropRef = useRef(setProp);
  setPropRef.current = setProp;

  const handleHiddenChange = useCallback(
    (checked: boolean) => {
      if (!fieldNodeId) return;
      setPropRef.current((props: T) => {
        props.hidden = checked;
      });
    },
    [fieldNodeId],
  );

  return { handleHiddenChange };
};

export default useFormFieldHiddenSync;
